const MuiAvatarGroup = {
  styleOverrides: {
    root: {
      '& .MuiAvatar-root': {
        border: 'none',
        marginLeft: '4px',
        '&:hover': {
          cursor: 'pointer'
        },
        '&:last-child': {
          marginLeft: '0px'
        }
      }
    }
  }
};
export default MuiAvatarGroup;